<template>
  <div id="error-page-root" class="text-center">
    <div>
      <v-alert prominent type="error">
        <v-row align="center">
          <v-col class="grow">{{ $store.state.errMessage }}</v-col>
          <!-- <v-col class="shrink">
            <v-btn color="primary" @click="close()">朕知道了</v-btn>
          </v-col> -->
        </v-row>
      </v-alert>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.console.error('[Error] ' + this.$store.state.errMessage)
  },
  methods: {
    close() {
      window.opener = null
      window.open('about:blank', '_top').close()
    }
  }
}
</script>

<style lang="scss" scoped>
#error-page-root {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
